import jQuery from 'jquery'
import * as lib from '../lib/lib'

export default class MyBookingsTables {
  constructor(element) {
    if (!element) {
      return false
    }

    this.$element = jQuery(element)
    this.tables = jQuery('.b-book-table', this.$element)
    this.tableHeads = jQuery('.b-book-table__acc__head', this.$element)
    this.interacted = false

    this._iniEvents()
  }

  _iniEvents() {
    this.toFocusThis(this.tableHeads)

    this.tableHeads.on('click', (e) => {
      const targetElement = jQuery(e.currentTarget)

      if (!this.interacted) {
        this.toggle(targetElement)
      }
    })

    jQuery('body').on('click.sortByButton', '.btn--sortby', (e) => {
      const targetElement = jQuery(e.currentTarget)

      if (targetElement.hasClass('force-submit')) {
        return true
      }

      e.preventDefault()

      if (targetElement.hasClass('asc')) {
        targetElement.removeClass('asc').addClass('desc')
      } else if (targetElement.hasClass('desc')) {
        targetElement.removeClass('desc')
      } else {
        targetElement.addClass('asc')
      }

      const attr = lib.getDataAttr(targetElement, 'rel', false)

      if (attr) {
        jQuery(attr).removeClass('asc').removeClass('desc')
      }
    })
  }

  toFocusThis(obj) {
    jQuery(obj).on('touchstart', (e) => {
      const targetElement = jQuery(e.currentTarget)

      targetElement.focus()
    })
  }

  closeAll(except) {
    let head

    if (except) {
      head = except.parent().find('.b-book-table__acc__head').not(except)
    } else {
      head = this.tableHeads.filter('.active')
    }

    head.removeClass('active')
    head.next().removeAttr('style')
  }

  toggle(head) {
    if (head.hasClass('active')) {
      this.close(head)
    } else {
      const otherHeads = head
        .parent()
        .find('.b-book-table__acc__head.active')
        .not(head)

      if (otherHeads.length) {
        this.close(otherHeads, () => {
          this.open(head)
        })
      } else {
        this.open(head)
      }
    }
  }

  open(head) {
    this.interacted = true

    head
      .next()
      .stop()
      .slideDown(300, () => {
        head.addClass('active')
        head.next().removeAttr('style')

        this.interacted = false
      })
  }

  close(head, callBack) {
    this.interacted = true

    head
      .next()
      .stop()
      .slideUp(300, () => {
        head.removeClass('active')
        head.next().removeAttr('style')

        this.interacted = false

        if (typeof callBack === 'function') callBack()
      })
  }
}
